import { createAction, props } from '@ngrx/store';
import { Domain, Competency , LearningOutcome } from '../assessment.state';

// Load/select a student
export const selectStudent = createAction(
  '[Assessment] Select Student',   // Action type (helps debugging in NgRx devtools)
  props<{ id: number; name: string; age: string }>() //Payload = selected student
);

// Select a domain
export const selectDomain = createAction(
  '[Assessment] Select Domain',    // Action type
  props<{ domain: Domain }>()      // Payload = selected domain
);

// Select a subdomain (competency)
export const selectSubDomain = createAction(
  '[Assessment] Select SubDomain',  // Action type
  props<{ subDomain: Competency }>()// Payload = selected subdomain
);

// Update a learning outcome inside a subdomain
export const selectLearningOutcome = createAction(
  '[Assessment] Update LearningOutcome',
  props<{ outcomes : any[] }>()
);

// Clear/reset all selections
export const resetAssessment = createAction(
  '[Assessment] Reset'              // Useful when switching students
);

// Handle async load start
export const setLoading = createAction(
  '[Assessment] Set Loading',
  props<{ loading: boolean }>()
);

// Handle error
export const setError = createAction(
  '[Assessment] Set Error',
  props<{ error: string | null }>()
);
